import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyA6wPPevys1cjGCeJKtFkzFIKNwlllPuns",
  authDomain: "netokos-469e0.firebaseapp.com",
  projectId: "netokos-469e0",
  storageBucket: "netokos-469e0.firebasestorage.app",
  messagingSenderId: "652076051917",
  appId: "1:652076051917:web:a4178b79fff4269b7f2884",
  measurementId: "G-GJ4ZNT49D2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);

// Az Analytics csak böngészőben (nem szerver-oldali renderelésnél) és csak
// akkor inicializálódik, ha a böngésző ténylegesen támogatja — az
// isSupported() ellenőrzés nélkül némely böngészőben/inkognitó módban
// hibát dobna.
export let analytics = null;
isSupported().then((tamogatott) => {
  if (tamogatott) {
    analytics = getAnalytics(app);
  }
});